var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import perks from "@irati/ui/images/logoPerks.png";
import recognition from "@irati/ui/images/logoRecognition.png";
import insights from "@irati/ui/images/logoInsights.png";
import medical from "@irati/ui/images/logoMedical.png";
import mobilePerks from "@irati/ui/images/logoMobilePerks.png";
import mobileRecognition from "@irati/ui/images/logoMobileRecognition.png";
import mobileInsights from "@irati/ui/images/logoMobileInsights.png";
import mobileMedical from "@irati/ui/images/logoMobileMedical.png";
import admin from "@irati/ui/images/logoAdmin.png";
import perkboxAlt from "@irati/ui/images/logo-alt.svg";
var logoCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 24px;\n  width: auto;\n"], ["\n  height: 24px;\n  width: auto;\n"])));
export var PerkboxLogo = styled.img.attrs({
    src: perkboxAlt,
    alt: "Perkbox"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var AdminLogo = styled.img.attrs({
    src: admin,
    alt: "Admin logo"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var PerksLogo = styled.img.attrs({
    src: perks,
    alt: "Perks logo"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var RecognitionLogo = styled.img.attrs({
    src: recognition,
    alt: "Recognition logo"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var InsightsLogo = styled.img.attrs({
    src: insights,
    alt: "Insights logo"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var MedicalLogo = styled.img.attrs({
    src: medical,
    alt: "Medical logo"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var MobilePerksLogo = styled.img.attrs({
    src: mobilePerks,
    alt: "Perks logo"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var MobileRecognitionLogo = styled.img.attrs({
    src: mobileRecognition,
    alt: "Recognition logo"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var MobileInsightsLogo = styled.img.attrs({
    src: mobileInsights,
    alt: "Insights logo"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
export var MobileMedicalLogo = styled.img.attrs({
    src: mobileMedical,
    alt: "Medical logo"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), logoCSS);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
